import { render, staticRenderFns } from "./NeoparentEvolution.vue?vue&type=template&id=75c992c8&scoped=true"
import script from "./NeoparentEvolution.vue?vue&type=script&lang=js"
export * from "./NeoparentEvolution.vue?vue&type=script&lang=js"
import style0 from "./NeoparentEvolution.vue?vue&type=style&index=0&id=75c992c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c992c8",
  null
  
)

export default component.exports